import { render, staticRenderFns } from "./RoughDiagBase.vue?vue&type=template&id=1254c977&"
import script from "./RoughDiagBase.vue?vue&type=script&lang=js&"
export * from "./RoughDiagBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports